import { render, staticRenderFns } from "./riskPreventionContractDialog.vue?vue&type=template&id=6b18e756&scoped=true"
import script from "./riskPreventionContractDialog.vue?vue&type=script&lang=js"
export * from "./riskPreventionContractDialog.vue?vue&type=script&lang=js"
import style0 from "./riskPreventionContractDialog.vue?vue&type=style&index=0&id=6b18e756&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b18e756",
  null
  
)

export default component.exports